<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4463 4.53907L12.5303 4.22965C12.4164 3.79493 12.2808 3.3666 12.1042 2.9535C11.7697 2.79259 11.4285 2.65099 11.0832 2.5218V0H9.91662L9.46774 2.04456C7.86347 1.69296 6.19113 1.67772 4.53121 2.04208L4.0832 0H2.91627V2.52358C2.57431 2.6517 2.23341 2.79153 1.89565 2.9535C1.71854 3.3666 1.58326 3.79493 1.46969 4.22965L0.553364 4.53907C0.248856 4.64185 0 4.99186 0 5.31688V7.67901C0 8.00385 0.248856 8.35403 0.553364 8.45681L1.47039 8.76588C1.58291 9.19457 1.71574 9.62149 1.8953 10.042C5.29966 11.6751 8.95445 11.5581 12.1042 10.042C12.2836 9.62149 12.4169 9.1951 12.5291 8.76659L13.4463 8.45681C13.7504 8.35403 14 8.00385 14 7.67901V5.31688C14 4.99186 13.7504 4.64185 13.4463 4.53907ZM11.1961 9.16108C9.84767 9.74607 8.43766 10.042 6.99878 10.042C5.56549 10.042 4.15618 9.74536 2.8034 9.16037C2.1732 7.42629 2.1732 5.56445 2.80322 3.83552C4.156 3.25017 5.56514 2.9535 6.99878 2.9535C8.43784 2.9535 9.84767 3.24981 11.1968 3.83445C11.8266 5.56445 11.8261 7.42629 11.1961 9.16108Z"
      :fill="props.fillColor"
    />
    <path
      d="M0.699707 12.9246V14C4.90128 13.2634 9.41204 13.3164 13.3 14V12.9246C9.23327 12.2321 4.77654 12.2316 0.699707 12.9246Z"
      :fill="props.fillColor"
    />
    <path
      d="M4.08325 5.16837V6.6453C4.08325 6.97173 4.34401 7.23596 4.66637 7.23596C4.98907 7.23596 5.24983 6.97173 5.24983 6.6453V5.16837C5.24983 4.84193 4.98907 4.57788 4.66637 4.57788C4.34401 4.57788 4.08325 4.84193 4.08325 5.16837Z"
      :fill="props.fillColor"
    />
    <path
      d="M8.74988 5.16837V6.6453C8.74988 6.97173 9.01081 7.23596 9.33317 7.23596C9.6557 7.23596 9.91663 6.97173 9.91663 6.6453V5.16837C9.91663 4.84193 9.6557 4.57788 9.33317 4.57788C9.01081 4.57788 8.74988 4.84193 8.74988 5.16837Z"
      :fill="props.fillColor"
    />
  </svg>
</template>
<script setup>
const props = defineProps({
  fillColor: {
    type: String,
    default: "#1B3936",
  },
});
</script>
